import React, { useState } from "react";
import { ToggleButton } from "@fluentui/react-components";

const DayButton = (props) => {
  const { btnText, onDayClick, btnClass, selectedDays, key, selectedDay, isToggle } = props;
  const [checked, setChecked] = useState(false);

  const handleToggle = () => {
    setChecked(!checked);
    onDayClick(btnText);
  };

  return (
    isToggle ? (
      <ToggleButton
      className={`${btnClass} ${selectedDay === btnText ? "checked" : ""}`}
      shape="circular"
      checked={selectedDay === btnText}
      onClick={handleToggle}
    >
      {btnText}
    </ToggleButton>
    ) : (
      <ToggleButton
        className={`${btnClass} ${
          selectedDays.map((item) => item.substring(0, 2)).includes(btnText)
            ? "checked"
            : ""
        }`}
        shape="circular"
        checked={checked}
        onClick={handleToggle}
      >
        {btnText}
      </ToggleButton>
    )
  );
};

export default DayButton;


// Logic for D and N in resource mangemnet screen 

// import React from "react";
// import { ToggleButton } from "@fluentui/react-components";

// const DayButton = (props) => {
//   const { btnText, onDayClick, btnClass, selectedDay, key } = props;

//   const handleToggle = () => {
//     onDayClick(btnText);
//   };

//   return (
//     <ToggleButton
//       className={`${btnClass} ${selectedDay === btnText ? "checked" : ""}`}
//       shape="circular"
//       checked={selectedDay === btnText}
//       onClick={handleToggle}
//     >
//       {btnText}
//     </ToggleButton>
//   );
// };

// export default DayButton;
